import WhatsMarked from 'react-whatsmarked';

// Bolha compacta estilo WhatsApp para prévia de mensagem do robô. Usa a mesma
// lib de markdown do ChatComponent (react-whatsmarked) e a mesma lógica de
// {{saudacao}} + quebra por {{dividir_texto}} do envio real — sem as margens
// fixas do ChatComponent, pra caber bem no card e no editor. Cores fixas do
// WhatsApp de propósito (é uma prévia do app, como um print).
//
// compact (nos cards da grade): limita a 3 balões e ~5 linhas por balão, com
// reticências, para a grade ficar uniforme e escaneável — mensagem curta vira
// card curto; mensagem longa (o resumo) é cortada. O texto completo aparece no
// editor.
const MAX_PARTS = 3;
const CLAMP_LINES = 5;

function saudacao() {
  const h = new Date().getHours();
  if (h < 12) return 'Bom dia!';
  if (h < 18) return 'Boa tarde!';
  return 'Boa noite!';
}

export default function MessageBubble({ text, compact = false }) {
  let parts = String(text ?? '')
    .replace('{{saudacao}}', saudacao())
    .split('{{dividir_texto}}')
    .map((m) => m.trim())
    .filter(Boolean);

  const truncated = compact && parts.length > MAX_PARTS;
  if (compact) parts = parts.slice(0, MAX_PARTS);

  const bodyStyle = compact
    ? { ...bodyBase, display: '-webkit-box', WebkitLineClamp: CLAMP_LINES, WebkitBoxOrient: 'vertical', overflow: 'hidden' }
    : bodyBase;

  return (
    <div style={{ ...bg, ...(compact ? { padding: 8 } : {}) }}>
      {parts.length === 0 ? (
        <div style={empty}>Sua mensagem aparecerá aqui</div>
      ) : (
        parts.map((p, i) => (
          <div key={i} style={bubble}>
            <div style={bodyStyle}>
              <WhatsMarked>{p}</WhatsMarked>
            </div>
            {!compact && <span style={time}>9:41 ✓✓</span>}
          </div>
        ))
      )}
      {truncated && <div style={more}>+ mais mensagens</div>}
    </div>
  );
}

const bg = { background: '#efeae2', borderRadius: 10, padding: 12, display: 'flex', flexDirection: 'column', gap: 4 };
const bubble = { alignSelf: 'flex-end', maxWidth: '92%', background: '#d9fdd3', border: '1px solid #c8ecb4', borderRadius: '8px 8px 2px 8px', padding: '6px 9px', fontSize: 12.5, lineHeight: 1.4, color: '#111b21' };
const bodyBase = { whiteSpace: 'pre-wrap', wordBreak: 'break-word' };
const time = { display: 'block', textAlign: 'right', fontSize: 10, color: '#5f7d6b', marginTop: 2 };
const empty = { textAlign: 'center', padding: '14px', fontSize: 12, color: '#7a8a80', fontStyle: 'italic' };
const more = { alignSelf: 'center', fontSize: 10.5, color: '#5f7d6b', marginTop: 2 };
